<template>
    <div>
        <ul class="uk-tab uk-text-large">
            <li :class="{'uk-active': !current_page||(current_page==='wps')}"><a href @click.prevent="current_page = 'wps'">Workload Projection</a></li>
            <li :class="{'uk-active': (current_page==='project-data')}"><a href @click.prevent="current_page = 'project-data'">Project Data</a></li>
            <li :class="{'uk-active': (current_page==='client-data')}"><a href @click.prevent="current_page = 'client-data'">Client</a></li>
            <li :class="{'uk-active': (current_page==='prospective-data')}"><a href @click.prevent="current_page = 'prospective-data'">Prospective</a></li>
            <li :class="{'uk-active': (current_page==='billing-schedule')}">
                <a href @click.prevent="current_page = 'billing-schedule'">Billing Schedule</a>
            </li>
            <!--
            <li :class="{'uk-active': (current_page==='closeout-data')}"><a href @click.prevent="current_page = 'closeout-data'">Project Closeout</a></li>
            //-->
            <li :class="{'uk-active': (current_page==='scratchpad')}"><a href @click.prevent="current_page = 'scratchpad'">Notes</a></li>
        </ul>

        <ul id="active-project-pages" class="uk-switcher uk-margin">
            <keep-alive>
                <project-task-tab
                    v-if="!current_page||(current_page==='wps')"
                    :record="record"
                    :editable="can_edit_wps"
                    class="uk-active"
                />

                <project-data-tab
                    v-else-if="(current_page==='project-data')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />

                <client-data-tab
                    v-else-if="(current_page==='client-data')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />

                <prospective-data-tab
                    v-else-if="(current_page==='prospective-data')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />
                <billing-schedule-tab
                    v-else-if="(current_page==='billing-schedule')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />
                <!--
                <closeout-data-tab
                    v-else-if="(current_page==='closeout-data')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />
                //-->

                <scratchpad-tab
                    v-else-if="(current_page==='scratchpad')"
                    :record="record"
                    :editable="editable"
                    class="uk-active"
                />
            </keep-alive>
        </ul>
    </div>
</template>

<script type="text/javascript">
import is_project from "./mixins/IsProject"
import project_utilities from "../../mixins/ProjectUtilities"
import string_utilities from "../../mixins/StringUtilities"

import ProjectTaskTab from "./ProjectTaskTab/ProjectTaskTab"
import BillingScheduleTab from "./BillingScheduleTab/BillingScheduleTab"
// import CloseoutDataTab from "./CloseoutDataTab/CloseoutDataTab"

export default {
    mixins: [is_project, project_utilities, string_utilities],
    components: {
        ProjectTaskTab,
        BillingScheduleTab
    },
    mounted () {
        this.set_default_page()
    },
    methods: {
        set_default_page () {
            const params = this.hash_params
            if(params && params.tab) {
                this.current_page = params.tab
                if(params.goto) {
                    setTimeout(() => {
                        // eslint-disable-next-line
                        UIkit.Utils.scrollToElement(UIkit.$("#" + params.goto), { offset: UIkit.$(".lam-page-title").outerHeight(true) })
                    }, 750)
                }
                window.location.hash = ""
            } else this.current_page = "wps" // if(!this.record || !this.record.completed_at)
            // else this.current_page = "closeout-data"
        }
    },
    computed: {
        can_edit_wps () {
            if(this.is_db_admin_active) return true
            else if(!this.record) return false
            return this.project_is_overhead(this.record) || this.editable
        }
    },
    props: {
        editable: {
            type: Boolean,
            default: true
        }
    },
    data () {
        return {
            current_page: "wps"
        }
    }
}
</script>
